import React from 'react';
import { OfferPage } from '../components/offer/OfferPage';
import { PACKAGES } from '../data/packages';
export function OfferRoute({
  slug
}: {
  slug: string;
}) {
  const data = PACKAGES[slug];
  if (!data) return null;
  return <OfferPage data={data} data-id="element-437" />;
}